<template>
  <div>
    <Head title="Products" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link href="/settings">Settings</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Products</li>
      </ol>
    </nav>
    <h1>Products</h1>

    <div class="d-flex justify-content-between mb-3">
      <search-filter v-model="form.search" @reset="reset" />

      <Link class="btn btn-primary" href="/settings/products/create">
        <span>Create Product</span>
      </Link>
    </div>

    <div class="content-box">
      <table class="table">
        <thead>
          <tr>
            <th>Product Name</th>
            <th>Category</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="product in products.data" :key="product.id">
            <td>
              <Link :href="`/settings/products/${product.id}/edit`">
                {{ product.name }}
              </Link>
            </td>
            <td>
              <Link :href="`/settings/products/${product.id}/edit`" tabindex="-1">
                {{ product.category }}
              </Link>
            </td>
          </tr>
          <tr v-if="products.data.length === 0">
            <td colspan="2">No products found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-3" :links="products.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    products: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/settings', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
